import { render, staticRenderFns } from "./RoofCalSetup.vue?vue&type=template&id=568db77c&scoped=true"
import script from "./RoofCalSetup.vue?vue&type=script&lang=js"
export * from "./RoofCalSetup.vue?vue&type=script&lang=js"
import style0 from "./RoofCalSetup.vue?vue&type=style&index=0&id=568db77c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568db77c",
  null
  
)

export default component.exports